import { BCMonth, UsersHourResponse } from '../TimeSheet/types';

export enum SharePeriod {
  ThreeDays = 'THREE_DAYS',
  FiveDays = 'FIVE_DAYS',
  TwoWeeks = 'TWO_WEEKS',
  Month = 'MONTH',
  ThreeMonths = 'THREE_MONTHS',
}

export interface SharedUser {
  userId: number;
  forename: string;
  surname: string;
  avatarUrl: string | null;
}

export interface SharedPartner {
  partnerId: number;
  name: string;
  color: string;
  active: boolean;
  mask: string;
  isVacation: boolean;
}

/** Returned to the author right after a link is created. */
export interface TimesheetShare {
  token: string;
  year: number;
  month: number;
  expirationDate: string;
  user: SharedUser;
}

/** Public description of a shared month, readable with the token alone. */
export interface SharedTimesheetInfo {
  year: number;
  month: number;
  expirationDate: string;
  user: SharedUser;
  legend: SharedPartner[];
}

export interface CreateShareBody {
  year: number;
  month: number;
  period: SharePeriod;
  userId?: number;
}

export type SharedCalendar = BCMonth;
export type SharedTimesheets = UsersHourResponse[];
